import React, { LinkHTMLAttributes } from "react";
import { Tooltip } from "@material-ui/core";
import { Container } from "./styles";

interface ButtonTableProps extends LinkHTMLAttributes<HTMLAnchorElement> {
  disabled?: boolean;
  tooltip?: string;
}

const ButtonTable: React.FC<ButtonTableProps> = ({ children, disabled, tooltip, ...rest }) => {
  const button = <a {...rest}>{children}</a>;

  if (disabled && tooltip) {
    return (
      <Container disabled={disabled}>
        <Tooltip title={tooltip} arrow>
          <span>{button}</span>
        </Tooltip>
      </Container>
    );
  }

  return <Container disabled={disabled}>{button}</Container>;
};

export default ButtonTable;
